export const CARD_COLOR = Styles.color.cardBackground;
